// @noflow
import { FirstRow, GraphLayout, ProductState, RecipesAreaContainer, ScheduleLayout } from './styles';

import { compose, groupBy } from 'lodash/fp';
import PropTypes from 'prop-types';
import * as React from 'react';

const groupChildren = compose(groupBy(x => x.type.areaName), React.Children.toArray);

const ProductPageLayout = ({ children }) => {
    const childrenByArea = groupChildren(children);
    return (
        <div>
            <FirstRow>
                <ProductState rightLine={!!childrenByArea['ScheduleArea']}>
                    {childrenByArea['DeviceStateArea']}
                </ProductState>
                {childrenByArea['ScheduleArea'] && <ScheduleLayout>{childrenByArea['ScheduleArea']}</ScheduleLayout>}
            </FirstRow>
            {childrenByArea['GraphArea'] && <GraphLayout>{childrenByArea['GraphArea']}</GraphLayout>}
            {childrenByArea['RecipesArea'] && (
                <div>
                    <RecipesAreaContainer>{childrenByArea['RecipesArea']}</RecipesAreaContainer>
                </div>
            )}
            {childrenByArea['ConditionalFeature'] && (
                <div>
                    <RecipesAreaContainer>{childrenByArea['ConditionalFeature']}</RecipesAreaContainer>
                </div>
            )}
            {childrenByArea['HistoryArea'] && <div>{childrenByArea['HistoryArea']}</div>}
        </div>
    );
};

ProductPageLayout.propTypes = {
    children: PropTypes.any
};

export default ProductPageLayout;



// WEBPACK FOOTER //
// ./src/components/widgets/layouts/product-page/index.js